
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/informacje-motoryzacja/data/[rok]",
      function () {
        return require("private-next-pages/informacje-motoryzacja/data/[rok]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/informacje-motoryzacja/data/[rok]"])
      });
    }
  